<template>
    <div class="setting-advanced-black-list">
        <div class="module-item-style">
            <div class="module-item-title">黑名单列表</div>
            <div class="module-item-tips">统一查看和管理所有已在黑名单的访客</div>
            <div class="black-list-container">
                <tableBox class="index-table"
                          :tableData="tableData"
                          :tableHead="tableHead"
                          :tableHandler="tableHandler"
                          :total="total"
                          @handleButton="handleOperate"
                          @pageHandler="pageOperate"
						  :delConfirmText="delConfirmText"
                ></tableBox>
            </div>
        </div>
    </div>
</template>

<script>
    import tableBox from '@/components/table/table'

    export default {
        name: 'setting-advanced-visitor-blacklist',
        components: {
            tableBox
        },
        data() {
            return {
                currentPage: 1,
                pageSize: 10,
                tableHandler: [
                    {label: "移除", type: 'del', methods: 'delMethods'},
                ],
                tableData: [],
                tableHead: [
                    {
                        label: '访客信息',
                        value: 'visitorName',
                        operate: false
                    }, {
                        label: '拉黑时间',
                        value: 'time',
                        operate: false
                    }, {
                        label: '操作人',
                        value: 'serviceName',
                        operate: false
                    }, {
                        label: '操作',
                        value: '',
                        width: '160',
                        operate: true,
                    }
                ],
                total: 0,
				delConfirmText:"确认将该访客从黑名单移除?"
            }
        },
        created() {
            this.getBlackListData()
        },
        mounted() {

        },
        methods: {
            /**
             * 表单操作
             * @param val
             */
            handleOperate(val) {
                if (val.methods == "delMethods") {
                    this.removeBlackList(val.row.visitorId)
                }
            },
            /**
             *  分页操作
             * @param val
             */
            pageOperate(val) {
                if (val.type == 'currentChange') {
                    this.currentPage = val.val
                } else if (val.type == "sizeChange") {
                    this.pageSize = val.val
                }
                this.getBlackListData()
            },
            getBlackListData() {
                this.$http.getBlackListAPI({
                    pageSize: this.pageSize,
                    pageNum: this.currentPage
                }).then(res => {
                    if (res.status == 1) {
                        this.tableData = res.data.blacklist
                        this.total = res.data.total
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            },
            /**
             * 移除黑名单
             * @param id
             */
            removeBlackList(id) {
                this.$http.removeBlackListAPI({
                    uid:id
                }).then(res => {
                    if(res.status == 1){
                        this.getBlackListData()
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                    }else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="scss">

</style>
